import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ClearButton,
  FilterButton,
  SaveFilterBlock
} from 'components/common/Elements/Elements';
import InputSearch from 'components/common/forms/InputSearch/InputSearch';
import SelectDropDown from 'components/common/Elements/SelectDropDown/SelectDropDown';
import {
  defaultFilters,
  defaultNavigation,
  EdgeFilters as EdgeFilterFields
} from '../helpers/configurates';
import { useEdgeDataGrid } from '../helpers/useEdgeDataGrid';
import { useTableSettings } from '../helpers/tableSettings';
import styles from '../styles.module.scss';

interface EdgeFiltersProps {
  useDataGridResultProps: ReturnType<typeof useEdgeDataGrid>;
}

const EdgeFilters = ({ useDataGridResultProps }: EdgeFiltersProps) => {
  const { t } = useTranslation('edges');

  const FILTER_DROPDOWNS: {
    key: keyof EdgeFilterFields;
    label: string;
    alwaysShow?: boolean;
  }[] = [
    {
      key: 'data_residency',
      label: t('EDGES_LIST_FILTERS.DATA_RESIDENCY'),
      alwaysShow: true
    },
    {
      key: 'region_name',
      label: t('EDGES_LIST_FILTERS.REGION_NAME'),
      alwaysShow: true
    },
    {
      key: 'region_provider',
      label: t('EDGES_LIST_FILTERS.REGION_PROVIDER'),
      alwaysShow: true
    },
    {
      key: 'edge_version',
      label: t('EDGES_LIST_FILTERS.EDGE_VERSION'),
      alwaysShow: true
    },
    { key: 'machine_type', label: t('EDGES_LIST_FILTERS.MACHINE_TYPE') },
    { key: 'machine_size', label: t('EDGES_LIST_FILTERS.MACHINE_SIZE') },
    { key: 'status', label: t('EDGES_LIST_FILTERS.EDGE_STATUS') }
  ];
  const {
    setFilter,
    filter,
    loaderTable,
    startFilter,
    setStartFilter,
    handleFilterInput,
    filterButton,
    setFilterButton,
    handleFilterButton,
    onClearSearch,
    filterBackend,
    setFilterBackend,
    visibleFilterSave,
    setVisibleFilterSave,
    visibleFilterEdit,
    setVisibleFilterEdit,
    changeFilter,
    setChangeFilter,
    trigerResetDatePicker,
    setTrigerResetDatePicker,
    tableConf,
    setTableConf,
    filters,
    selectLoader,
    triggerSaveTableSettings,
    resetAllfilters
  } = useDataGridResultProps;

  const { tableConfig } = useTableSettings();

  const handleFilterChange = (key: string) => (value: string) => {
    setFilter({ ...filter, [key]: value, currentPage: 1 });
    setStartFilter(!startFilter);
  };

  return (
    <>
      <div className={styles.filtersMain}>
        <InputSearch
          placeholder={t('EDGES_LIST.SEARCH_PLACEHOLDER')}
          value={filter.search}
          onChange={handleFilterInput}
          onClearSearch={onClearSearch}
          className={styles.filterInput}
          disabled={loaderTable}
        />
        <FilterButton active={filterButton} onClick={handleFilterButton} />
        <SaveFilterBlock
          setFilterButton={setFilterButton}
          visibleFilterSave={visibleFilterSave}
          setVisibleFilterSave={setVisibleFilterSave}
          visibleFilterEdit={visibleFilterEdit}
          setVisibleFilterEdit={setVisibleFilterEdit}
          filter={filter}
          setFilter={setFilter}
          filterBackend={filterBackend}
          setFilterBackend={setFilterBackend}
          changeFilter={changeFilter}
          setChangeFilter={setChangeFilter}
          resetAllfilters={resetAllfilters}
          defaultNavigation={defaultNavigation}
          trigerResetDatePicker={trigerResetDatePicker}
          setTrigerResetDatePicker={setTrigerResetDatePicker}
          startFilter={startFilter}
          setStartFilter={setStartFilter}
          defaultFilters={defaultFilters}
          tableConf={tableConf}
          defaulTableConf={tableConfig}
          setTableConf={setTableConf}
          triggerSaveTableSettings={triggerSaveTableSettings}
        />
      </div>

      {filterButton && (
        <div className={styles.filtersRow}>
          {FILTER_DROPDOWNS.map(({ key, label, alwaysShow }) => {
            const options = (filters as EdgeFilterFields)?.[key];
            const hasOptions = Array.isArray(options) && options.length > 0;

            if (!alwaysShow && !hasOptions) return null;

            return (
              <SelectDropDown
                key={key}
                label={label}
                input={{
                  value: (filter as EdgeFilterFields)[key] ?? '',
                  onChange: handleFilterChange(key)
                }}
                options={
                  hasOptions
                    ? options.map((o: string) => ({
                        value: o,
                        label: o
                      }))
                    : []
                }
                selectLoader={selectLoader}
                isDisabled={loaderTable || !hasOptions}
              />
            );
          })}
          <ClearButton
            onClick={() => resetAllfilters(false, true, false, true)}
            numberОfFilters={7}
          />
        </div>
      )}
    </>
  );
};

export default EdgeFilters;
